import { Injectable, Injector } from '@angular/core';

// TODO: can we use inject?
@Injectable({ providedIn: 'root' })
export class InjectorLocatorService {
  static injector: Injector;
}
